export class ListController {
    constructor($scope, $injector, $translate) {
        this.scope = $scope;
        this.injector = $injector;
        this.translate = $translate;

        this.alert = this.injector.get('Alert');
        this.api = this.injector.get('$http');
        this.fileSaver = this.injector.get('FileSaver');

        this.store = this.injector.get('Exports');
        this.store.commit('setVm', this);
        this.store.dispatch('registerPusherListeners');

        this.scope.$on('$destroy', () => {
            this.store.dispatch('unregisterPusherListeners');
        });
    }

    deleteExport(row) {
        this.alert.confirm({
            title: 'Delete Export',
            message: 'Are you sure, you want to delete the export?',
            type: 'warning',
            wait: true,
            confirmBtn: 'Yes, delete',
            confirmBtnColor: '#ed5565'
        })
            .then(() => {
                this.api.delete(`exports/${row.id}`)
                    .then(() => {
                        this.store.dispatch('getData');
                        this.alert.success('Success', 'Export was deleted');
                        this.alert.hide();
                    })
                    .catch((e) => {
                        this.alert.handle(e);
                    })
            });
    }

    downloadExport({action, row}, store) {
        if(row.status !== 'finished' || !row.export_file) {
            const translatedValue = (path) => {
                return this.translate.instant(`exports.controllers.error_export_download_not_available.${path}`);
            };

            this.alert.animatedAlert(
                translatedValue('title'),
                translatedValue('content'),
                'attention',
                {
                    confirmButtonText: translatedValue('confirm'),
                    showCancelButton: false,
                }
            );
            return;
        }

        this.api.get(row.export_file.url, {responseType: "blob"})
            .then((response) => {
                const blob = new Blob([response.data], {type: response.headers('content-type')});
                this.fileSaver.saveAs(blob, row.export_file.name);
            }, (response) => {

                const translatedValue = (path) => {
                    return this.translate.instant(`exports.controllers.error_export_download.${path}`);
                };

                this.alert.animatedAlert(
                    translatedValue('title'),
                    translatedValue('content'),
                    'failed',
                    {
                        confirmButtonText: translatedValue('confirm'),
                        showCancelButton: false,
                        confirmButtonColor: '#e01249'
                    }
                );
            });
    }
}

ListController.$inject = [
    '$scope',
    '$injector',
    '$translate'
];



// WEBPACK FOOTER //
// ./src/app/modules/exports/controllers/list-controller.js